import React from "react";
import { useNavigate } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { Wordmark } from "./Logo";
import { Motif } from "./Motif";
import { NAV_LINKS, scrollToId } from "../../data/site";
import { resetConsent } from "./cookieConsent";

export const Footer = () => {
  const navigate = useNavigate();
  const go = (href) => scrollToId(href);
  return (
    <footer className="relative overflow-hidden bg-kern-bg border-t border-kern-taupe/15">
      <div className="pointer-events-none absolute right-[-4rem] bottom-[-6rem] w-[360px] h-[360px]">
        <Motif opacity={0.12} />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-16 grid gap-10 md:gap-12 sm:grid-cols-2 lg:grid-cols-5">
        <div className="sm:col-span-2 lg:col-span-2">
          <Wordmark />
          <p className="mt-5 text-sm text-kern-taupe max-w-xs leading-relaxed">
            "Wanneer je de kern begrijpt, ontstaat ruimte om te groeien"
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.22em] uppercase text-kern-taupe mb-5">Menu</h4>
          <ul className="space-y-3">
            {NAV_LINKS.filter((l) => l.href !== "#home").map((l) => (
              <li key={l.href}>
                <button
                  data-testid={`footer-link-${l.href.slice(1)}`}
                  onClick={() => go(l.href)}
                  className="text-sm text-kern-dark/80 hover:text-kern-terracotta transition-colors duration-300"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <button
                data-testid="footer-link-faq"
                onClick={() => navigate("/faq")}
                className="text-sm text-kern-dark/80 hover:text-kern-terracotta transition-colors duration-300"
              >
                Veelgestelde vragen
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.22em] uppercase text-kern-taupe mb-5">Praktijk</h4>
          <ul className="space-y-3 text-sm text-kern-dark/80">
            <li>E. Van Notenlaan 25</li>
            <li>2960 Sint-Lenaarts</li>
            <li>info@praktijk-dekern.be</li>
            <li>0496 / 43 49 95</li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.22em] uppercase text-kern-taupe mb-5">Volg ons</h4>
          <div className="flex gap-3">
            <a href="https://www.instagram.com/praktijk_dekern/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram"
              className="w-11 h-11 rounded-full bg-white flex items-center justify-center text-kern-olive hover:bg-kern-sage/30 transition-colors duration-300">
              <Instagram size={18} />
            </a>
            <a href="https://www.facebook.com/share/1bM3GZdYjt/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="social-facebook"
              className="w-11 h-11 rounded-full bg-white flex items-center justify-center text-kern-olive hover:bg-kern-sage/30 transition-colors duration-300">
              <Facebook size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="relative border-t border-kern-taupe/15">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-kern-taupe">
          <p>© {new Date().getFullYear()} Praktijk De Kern. Alle rechten voorbehouden.</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <button
              data-testid="footer-link-privacy"
              onClick={() => navigate("/privacy")}
              className="hover:text-kern-terracotta transition-colors duration-300"
            >
              Privacyverklaring
            </button>
            <button
              data-testid="footer-link-cookies"
              onClick={() => navigate("/cookiebeleid")}
              className="hover:text-kern-terracotta transition-colors duration-300"
            >
              Cookiebeleid
            </button>
            <button
              data-testid="footer-link-terms"
              onClick={() => navigate("/algemene-voorwaarden")}
              className="hover:text-kern-terracotta transition-colors duration-300"
            >
              Algemene voorwaarden
            </button>
            <button
              data-testid="footer-link-cookie-prefs"
              onClick={resetConsent}
              className="hover:text-kern-terracotta transition-colors duration-300"
            >
              Cookievoorkeuren
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
